
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/events-festivals",
      function () {
        return require("private-next-pages/events-festivals.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/events-festivals"])
      });
    }
  